<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-8 mb-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Name"
              aria-label="Name"
              aria-describedby="Name"
              v-model="search_text"
            />
            <div class="input-group-append">
              <button class="btn btn-info" type="button" @click="getCreditPackages(1)">Search</button>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-1 text-right">
          <base-button type="primary" size="md" @click="openCreateModal()">Create New</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark': ''"
        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
        tbody-classes="list"
        :data="creditPackages"
      >
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Name</th>
          <th class="text-center">Recommended</th>
          <th class="text-center">Price (BND)</th>
          <th class="text-center">Credits (per month)</th>
          <th class="text-center">Status</th>
          <th class="text-center">Created Date</th>
          <th class="text-center">Actions</th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.name}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <!-- <span class="name mb-0 text-sm" v-if="row.recommended === '1'">Yes</span> -->
                <i class="ni ni-check-bold" v-if="row.recommended === '1'"></i>
                <i class="ni ni-fat-remove" v-if="row.recommended === '0'"></i>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.price}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.credits}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 0">Inactive</span>
                <span class="name mb-0 text-sm text-success" v-if="row.status == 1">Active</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.created_date}}</span>
              </div>
            </div>
          </td>
          <td class="text-right">
            <base-dropdown class="dropdown" position="right">
              <a
                slot="title"
                class="btn btn-sm btn-icon-only text-light"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" href="#" @click="openUpdatePackage(row.id)">Update</a>
                <a
                  class="dropdown-item"
                  href="#"
                  @click="updatePackageStatus(row.id, 1)"
                  v-if="row.status == 0"
                >Activate</a>
                <a
                  class="dropdown-item"
                  href="#"
                  @click="updatePackageStatus(row.id, 0)"
                  v-if="row.status == 1"
                >Deactivate</a>
                <a class="dropdown-item" href="#" @click="deletePackage(row.id)">Delete</a>
              </template>
            </base-dropdown>
          </td>
        </template>
      </base-table>
    </div>

    <div class="row" id="div-create_package_modal">
      <div class="col-md-4">
        <modal
          :show.sync="modals.create_package_modal"
          body-classes="p-0"
          modal-classes="modal-dialog-centered modal-lg"
        >
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-4"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
            <template>
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0" v-if="update == false">CREATE NEW CREDIT PACKAGE</h3>
                    <h3 class="mb-0" v-if="update == true">UPDATE PACKAGE</h3>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div>
                  <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Name:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <base-input
                        alternative
                        placeholder="Name"
                        input-classes="form-control-alternative"
                        type="text"
                        v-model="createCreditPackage.name"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Price (BND):
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <base-input
                        alternative
                        placeholder="Price (BRN)"
                        input-classes="form-control-alternative"
                        type="number"
                        v-model="createCreditPackage.price"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3">Recommended:</label>
                    <div class="col-sm-9">
                      <base-checkbox class="mb-3" v-model="createCreditPackage.recommended"></base-checkbox>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">
                      Description:
                      <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-9">
                      <base-input
                        alternative
                        placeholder="Description"
                        input-classes="form-control-alternative"
                        type="text"
                        v-model="createCreditPackage.description"
                      />
                    </div>
                  </div>
                  <div class="text-center">
                    <base-button
                      type="danger"
                      class="my-4"
                      @click="modals.create_package_modal = false; update = false;"
                    >Cancel</base-button>
                    <base-button
                      type="success"
                      class="my-4"
                      @click="createPackage()"
                      v-if="update == false"
                    >Create</base-button>
                    <base-button
                      type="success"
                      class="my-4"
                      @click="updatePackage(creditPackageId)"
                      v-if="update == true"
                    >Update</base-button>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </modal>
      </div>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination :perPage="10" :total="totalCreditPackage" :value="pageNumber"></base-pagination>
      <!-- <div class="row"> -->
      <!-- <div class="col-10"></div>
      <div class="col-2"><base-pagination :perPage="5" :total="creditPackages.length"></base-pagination></div>-->
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import EventBus from "./../../event-bus";

export default {
  name: "credit-packages-table",
  props: {
    type: {
      type: String
    },
    title: String,
    status: String
  },
  data() {
    return {
      search_text: "",
      creditPackages: [],
      show: false,
      message: "",
      totalCreditPackage: 0,
      totalCreditPackageTransaction: "0",
      createCreditPackage: {
        name: "",
        price: 0.0,
        recommended: false,
        description: ""
      },
      modals: {
        create_package_modal: false
      },
      update: false,
      creditPackageId: 0
    };
  },
  mounted() {
    this.getCreditPackages(1);
    this.getTotalCreditPackage();
  },
  computed: {
    pageNumber() {
      return parseInt(this.$route.query.page);
    }
  },
  watch: {
    pageNumber() {
      this.getCreditPackages(this.$route.query.page);
    },
    status: function() {
      this.getCreditPackages(this.$route.query.page);
    }
  },
  methods: {
    getCreditPackages: function(page_number) {
      this.$store
        .dispatch("fetchCreditPackages", {
          keyword: this.search_text, 
          page: page_number,
          status: this.status
        })
        .then(response => {
          const { data, meta } = response.data;
          this.totalCreditPackage = meta.total_result;
          let responseData = data;
          this.creditPackages = responseData;
          this.$router.push({ query: { page: page_number } });
        })
        .catch(e => {
          console.log(e);
        });
    },

    getTotalCreditPackage() {
      this.$store
        .dispatch("fetchTotalCreditPackage", { status: this.status })
        .then(response => {
          let responseData = response.data;
          this.totalCreditPackage = parseInt(responseData);
        })
        .catch(e => {
          console.log(e);
        });
    },

    getTotalCreditPackageTransaction() {
      this.$store
        .dispatch("fetchTotalCreditPackageTransaction")
        .then(response => {
          let responseData = response.data;
          this.totalCreditPackageTransaction = responseData;
        })
        .catch(e => {
          console.log(e);
        });
    },

    createPackage() {
      this.$store
        .dispatch("createPackage", {
          name: this.createCreditPackage.name,
          price: parseFloat(this.createCreditPackage.price).toFixed(2),
          recommended: this.createCreditPackage.recommended,
          description: this.createCreditPackage.description
        })
        .then(response => {
          if (response.data.error == "1000") {
            var page = this.$route.query.page;
            if ((this.totalCreditPackage % 10) === 0) {
              page++;
            }
            this.modals.create_package_modal = false;
            this.getCreditPackages(page);
            this.getTotalCreditPackage();

            EventBus.$emit("getTotalPackage");
            EventBus.$emit("getTotalActivePackage");
          } else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        })
        .catch(error => {
          console.log(error.message);
        });
    },

    updatePackage() {
      this.$store
        .dispatch("updatePackage", {
          package_id: this.creditPackageId,
          name: this.createCreditPackage.name,
          price: parseFloat(this.createCreditPackage.price).toFixed(2),
          description: this.createCreditPackage.description,
          recommended: this.createCreditPackage.recommended
        })
        .then(response => {
          if (response.data.error == "1000") {
            this.modals.create_package_modal = false;
            this.getCreditPackages(this.$route.query.page);
          } else if (response.data.error == "9999") {
            this.message = response.data.message;
            this.show = true;
          }
        })
        .catch(error => {
          console.log(error.message);
        });
    },

    deletePackage: function(package_id) {
      var result = confirm('Are you sure want to delete?');
      if(result)
      {
        this.$store
          .dispatch("deletePackage", {
            package_id: package_id
          })
          .then(response => {
            var page = this.$route.query.page;
            if ((this.totalCreditPackage % 10) === 1) {
              page--;
            }
            this.getCreditPackages(page);
            this.getTotalCreditPackage();
            EventBus.$emit("getTotalPackage");
            EventBus.$emit("getTotalActivePackage");
            EventBus.$emit("getTotalInactivePackage");
          })
          .catch(error => {
            console.log(error.message);
          });
      }
    },

    openUpdatePackage: function(package_id) {
      this.show = false;
      this.message = "";
      this.modals.create_package_modal = true;
      this.update = true;
      this.$store
        .dispatch("fetchCreditPackage", {
          package_id: package_id
        })
        .then(response => {
          let responseData = response.data;

          this.creditPackageId = package_id;
          this.createCreditPackage.name = responseData.name;
          this.createCreditPackage.price = responseData.price;
          this.createCreditPackage.recommended =
            responseData.recommended == "0" ? false : true;
          this.createCreditPackage.description = responseData.description;
        })
        .catch(error => {
          console.log(error.message);
        });
    },

    updatePackageStatus: function(package_id, status) {
      this.$store
        .dispatch("updatePackageStatus", {
          package_id: package_id,
          status: status
        })
        .then(response => {
          if (response.data.error == "1000") {
            this.getCreditPackages(this.$route.query.page);
            EventBus.$emit("getTotalActivePackage");
            EventBus.$emit("getTotalInactivePackage");
          }
        })
        .catch(error => {
          console.log(error.message);
        });
    },

    openCreateModal: function() {
      this.modals.create_package_modal = true;
      this.show = false;
      this.message = "";
      this.createCreditPackage.name = "";
      this.createCreditPackage.price = 0.0;
      this.createCreditPackage.recommended = false;
      this.createCreditPackage.description = "";
    }
  }
};
</script>
<style>
</style>
